console.log('this file is a placeholder and is never trully run. It just loads the CSS')
